/***
 * Validate a expression to make sure it's safe to use
 */
const normalizeExpression = (expression: string): string => expression.replace(/\s+/g, "");

const validateRuleExpression = (expression: string): boolean => {
    let isInSingleQuotes = false;
    let isInDoubleQuotes = false;
    const teststring = expression.replaceAll("true", "").replaceAll("false", "").replaceAll("includes", "");
    if (teststring.length > 2000) {
        // Safeguard against potential overflow attacks
        return false;
    }
    for (let ix = 0; ix < teststring.length; ix++) {
        let isLegal = false;
        const ch = teststring[ix];
        if ("+-*/%!&()=|<> 0123456789".includes(ch)) {
            isLegal = true;
        }
        else {
            if (isInSingleQuotes) {
                isLegal = true;
                if ("'" === ch) {
                    isInSingleQuotes = false;
                }
            }
            else if (isInDoubleQuotes) {
                isLegal = true;
                if ('"' === ch) {
                    isInDoubleQuotes = false;
                }
            }
            else if ("'" === ch) {
                isInSingleQuotes = true;
                isLegal = true;
            }
            else if ('"' === ch) {
                isInDoubleQuotes = true;
                isLegal = true;
            }
        }
        if (!isLegal) {
            console.log("Illegal expression ignored", expression);
            return false;
        }
    }
    return true;
}

/***
 * Evaluates an expression and returns true or false
 */
export function evaluateBooleanExpression(expression: string): boolean {
    try {
        const normalizedExpression = normalizeExpression(expression);
        // eslint-disable-next-line no-eval
        return validateRuleExpression(normalizedExpression) ? !!eval(normalizedExpression) : false;
    }
    catch (error) {
        console.log("Error evaluating expression", expression, error);
        return false;
    }
}

/***
 * Evaluates an expression and returns a number
 */
export function evaluateNumberExpression(expression: string): number {
    try {
        const normalizedExpression = normalizeExpression(expression);
        // eslint-disable-next-line no-eval
        const value = validateRuleExpression(normalizedExpression) ? eval(normalizedExpression) : NaN;
        if (value !== null && value !== undefined && typeof value === "number") {
            return value;
        }
        return NaN;
    }
    catch (error) {
        console.log("Error evaluating expression", expression, error);
        return NaN;
    }
}

/***
 * Evaluates an expression and returns the result
 */
export function evaluateExpression(expression: string): any {
    try {
        const normalizedExpression = normalizeExpression(expression);
        // eslint-disable-next-line no-eval
        return validateRuleExpression(normalizedExpression) ? eval(normalizedExpression) : null;
    }
    catch (error) {
        console.log("Error evaluating expression", expression, error);
        return null;
    }
}
